import React, { useEffect, useState, useCallback } from 'react';
import Menu from "../../comum/Menu/index.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import Foto from "../Components/Foto";
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function calcularDistancia(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

const Equipamentos = () => {
    const [itens, setItens] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [lojaSelecionada, setLojaSelecionada] = useState(null);
    const [dentroDoRaio, setDentroDoRaio] = useState(false);
    const [loading, setLoading] = useState(true);
    const [analiseData, setAnaliseData] = useState(null);
    const [itemSelecionado, setItemSelecionado] = useState(null);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);

    const permiteRegional = localStorage.getItem("permiteRegional") === 'S' || localStorage.getItem("diretor") === 'S';

    const buscarDados = useCallback(async (codEmp) => {
        setLoading(true);
        try {
            const res = await api.get(`/equipamentos/${codEmp}`);
            setItens(res.data);
        } catch (err) {
            Swal.fire('Erro', 'Erro ao carregar equipamentos.', 'error');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        const inicializarComponente = async () => {
            setLoading(true);
            let listaLojas = [];

            try {
                const resp = await api.get("lojas/localizacao");
                listaLojas = resp.data || [];
                setLojas(listaLojas);

                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        async (pos) => {
                            const { latitude, longitude } = pos.coords;
                            const lojaProxima = listaLojas.find((loja) => {
                                const distKm = calcularDistancia(
                                    latitude,
                                    longitude,
                                    parseFloat(loja.latitude),
                                    parseFloat(loja.longitude)
                                );
                                return (distKm * 1000) <= parseFloat(loja.distancia || 0);
                            });

                            if (lojaProxima) {
                                setLojaSelecionada(lojaProxima);
                                setDentroDoRaio(true);
                            } else {
                                fallbackLocalStorage(listaLojas, "Você não está no raio de nenhuma loja.");
                            }
                        },
                        (err) => {
                            fallbackLocalStorage(listaLojas, "GPS indisponível ou permissão negada.");
                        },
                        { timeout: 10000, enableHighAccuracy: true }
                    );
                } else {
                    fallbackLocalStorage(listaLojas, "Geolocalização não suportada.");
                }
            } catch (error) {
                console.error("Erro inicial:", error);
                setLoading(false);
            }
        };

        const fallbackLocalStorage = (lista, motivo) => {
            // CORREÇÃO: Usando 'let' para permitir a reatribuição e tratando como número
            let idLojaSalva = localStorage.getItem("loja");

            if (Number(idLojaSalva) > 36) {
                idLojaSalva = 5;
            }

            console.log('Loja Fallback: ' + idLojaSalva);
            const lojaPadrao = lista.find(l => String(l.cod_emp) === String(idLojaSalva));

            if (lojaPadrao) {
                setLojaSelecionada(lojaPadrao);
                setDentroDoRaio(false);
                Swal.fire("Atenção", `${motivo} Usando loja padrão do perfil.`, "info");
            } else {
                setLoading(false);
                Swal.fire("Erro", "Não foi possível identificar sua loja.", "error");
            }
        };

        inicializarComponente();
    }, []);

    useEffect(() => {
        if (lojaSelecionada) {
            buscarDados(lojaSelecionada.cod_emp);
        }
    }, [lojaSelecionada, buscarDados]);

    const handleSalvar = async (idEquip, valor) => {
        if (!valor && valor !== 0) return;
        setLoading(true);
        try {
            await api.post('/equipamentos/contagem', {
                id_loja: lojaSelecionada.cod_emp,
                id_equip: idEquip,
                qtd_contada: parseInt(valor)
            });
            Swal.fire({ title: 'Sucesso!', icon: 'success', timer: 1500, showConfirmButton: false });
            buscarDados(lojaSelecionada.cod_emp);
        } catch (err) {
            setLoading(false);
            Swal.fire('Erro', 'Falha ao salvar contagem', 'error');
        }
    };

    const verAnalise = async (item) => {
        setLoading(true);
        setItemSelecionado(item);
        try {
            const res = await api.get(`/equipamentos/analise/${lojaSelecionada.cod_emp}/${item.id_equip}`);
            const chartData = {
                labels: res.data.map(d => d.data_ref),
                datasets: [{
                    label: 'Saldo em Estoque',
                    data: res.data.map(d => Math.round(d.saldo_final)),
                    borderColor: '#3498db',
                    backgroundColor: 'rgba(52, 152, 219, 0.2)',
                    tension: 0.3,
                    fill: true
                }]
            };
            setAnaliseData(chartData);
        } catch (err) {
            Swal.fire('Erro', 'Falha ao carregar análise', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Menu modulo="ARBOR" />

            {/* Modal de Loading com Z-Index alto */}
            {loading && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(255,255,255,0.9)', zIndex: 99999,
                    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
                }}>
                    <div className="spinner-border text-primary" role="status" style={{ width: '3.5rem', height: '3.5rem' }}></div>
                    <span className="mt-3 fw-bold text-primary italic">Processando, aguarde...</span>
                </div>
            )}

            <div className="container-fluid mt-4 mb-5" style={{ paddingTop: '50px' }}>
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-12 text-center">
                        <h4 className="mb-4">Controle de Equipamentos</h4>

                        <div className="mb-3 text-start">
                            <label className="fw-bold small text-muted ms-1">LOJA ATUAL</label>
                            <input
                                className="form-control text-center bg-light fw-bold"
                                value={lojaSelecionada?.razao || "Localizando..."}
                                readOnly
                            />
                        </div>

                        {permiteRegional && (
                            <div className="mb-4 p-3 border rounded bg-white shadow-sm text-start">
                                <label className="small fw-bold text-primary">TROCAR LOJA (MODO GESTÃO):</label>
                                <select
                                    className="form-select mt-1"
                                    value={lojaSelecionada?.cod_emp || ""}
                                    onChange={(e) => {
                                        const novaLoja = lojas.find(l => String(l.cod_emp) === String(e.target.value));
                                        if (novaLoja) {
                                            setLojaSelecionada(novaLoja);
                                            setDentroDoRaio(true);
                                        }
                                    }}
                                >
                                    <option value="">Selecione uma loja...</option>
                                    {lojas.map(l => (
                                        <option key={l.cod_emp} value={l.cod_emp}>{l.razao}</option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {!dentroDoRaio && !loading && !permiteRegional && (
                            <div className="alert alert-warning py-2 small shadow-sm">
                                ⚠️ Lançamentos desativados por localização.
                            </div>
                        )}
                    </div>
                </div>

                <div className="row mt-2">
                    {itens.map((item) => (
                        <div className="col-md-4 col-sm-6 col-12 mb-3" key={item.id_equip}>
                            <div className="card shadow-sm border-0 h-100">
                                <div
                                    className="text-center bg-light border-bottom"
                                    style={{ height: '180px', overflow: 'hidden', cursor: 'pointer' }}
                                    onClick={() => setFotoSelecionada({
                                        foto: item.foto ? `data:image/jpeg;base64,${item.foto}` : null,
                                        nome: item.descricao,
                                        loja: lojaSelecionada?.razao
                                    })}
                                >
                                    {item.foto ? (
                                        <img
                                            src={`data:image/jpeg;base64,${item.foto}`}
                                            alt={item.descricao}
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                        />
                                    ) : (
                                        <div className="d-flex align-items-center justify-content-center h-100 text-muted small">
                                            Sem foto
                                        </div>
                                    )}
                                </div>

                                <div className="card-body d-flex flex-column">
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        {/* A mágica do wrap no mobile: minWidth 0 e wordBreak */}
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <h6 className="fw-bold mb-1" style={{
                                                fontSize: '0.9rem',
                                                lineHeight: '1.3',
                                                minHeight: '2.6em',
                                                display: '-webkit-box',
                                                WebkitLineClamp: '3',
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'visible',
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word'
                                            }}>
                                                {item.descricao}
                                            </h6>
                                            <p className="small text-muted mb-0">Saldo: <strong>{item.saldo}</strong></p>
                                            <button className="btn btn-sm btn-outline-info border-0 ms-2" onClick={() => verAnalise(item)}>
                                                📊
                                            </button>
                                        </div>

                                    </div>

                                    <div className="input-group mt-auto">
                                        <input
                                            // A KEY é o segredo: se o ID do equipamento ou o valor mudar, 
                                            // o React recria o input e limpa/preenche o campo corretamente.
                                            key={`input-${item.id_equip}-${item.qtd_hoje}`}

                                            type="number"
                                            className="form-control form-control-sm"
                                            placeholder="Qtd"
                                            id={`input-${item.id_equip}`}

                                            // defaultValue permite que você digite
                                            defaultValue={item.qtd_hoje ?? ""}

                                            // Regra de desabilitar
                                            disabled={(item.qtd_hoje !== null && item.qtd_hoje !== undefined)}
                                        />
                                        <button
                                            className={`btn btn-sm ${item.qtd_hoje !== null ? 'btn-success' : 'btn-primary'}`}
                                            // CORREÇÃO 3: Segue a mesma lógica do input para o botão
                                            disabled={!dentroDoRaio || (item.qtd_hoje !== null && item.qtd_hoje !== undefined)}
                                            onClick={() => handleSalvar(item.id_equip, document.getElementById(`input-${item.id_equip}`).value)}
                                        >
                                            {item.qtd_hoje !== null ? '✔' : 'Salvar'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Modal de Gráfico */}
                {analiseData && (
                    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 10000 }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content border-0 shadow">
                                <div className="modal-header bg-primary text-white">
                                    <h5 className="modal-title h6">{itemSelecionado?.descricao}</h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={() => setAnaliseData(null)}></button>
                                </div>
                                <div className="modal-body" style={{ height: '350px' }}>
                                    <Line
                                        data={analiseData}
                                        options={{
                                            maintainAspectRatio: false,
                                            responsive: true,
                                            scales: {
                                                y: {
                                                    ticks: {
                                                        precision: 0, // remove casas decimais
                                                        stepSize: 1   // força salto de 1 em 1
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Foto
                    show={!!fotoSelecionada}
                    onClose={() => setFotoSelecionada(null)}
                    foto={fotoSelecionada?.foto}
                    nome={fotoSelecionada?.nome}
                    info01={fotoSelecionada?.loja}
                    info02=""
                />
            </div>
            <Footer />
        </>
    );
};

export default Equipamentos;